import { timeslotsBranchesServices, timeslotsServices } from 'api/services';
import { IResTimeslot, ITimeslotParams } from 'api/services/timeslots/types';
import { IResTimeslotsBranch } from 'api/services/timeslotsBranches/types';
import ringtone from 'assets/sounds/rington.mp3';
import cn from 'classnames';
import { TimeslotsBranchesList } from 'components/TimeslotsBranchesList/TimeslotsBranchesList';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import { AppState } from 'store/store';

import './QueueWithTimeslotsPage.sass';

export const QueueWithTimeslotsPage: React.FC = () => {
  const [timeslotsBranches, setTimeslotsBranches] = useState<
    IResTimeslotsBranch[]
  >([]);
  const [timeslots, setTimeslots] = useState<IResTimeslot[]>([]);
  const [activeTimeslot, setActiveTimeslot] = useState<IResTimeslot>();
  const [loading, setLoading] = useState(false);

  const lang = useSelector((state: AppState) => state.i18n.key);
  const i18n = useSelector(
    (state: AppState) => state.i18n.data.pages.timeslotsPage,
  );

  const query = new URLSearchParams(useLocation().search);
  const branchIdFromQuery = query.get('branchId');

  const { queueId } = useParams<{ queueId: string }>();

  useEffect(() => {
    document.addEventListener('click', disableMouseEvents, true);
    return () => {
      document.removeEventListener('click', disableMouseEvents, true);
    };
  }, [lang, queueId]);

  const disableMouseEvents = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
  };

  useEffect(() => {
    getTimeslots();
  }, []);

  useEffect(() => {
    checkActiveTimeslot();
    const timer = setInterval(() => {
      checkActiveTimeslot();
    }, 10000);
    return () => clearInterval(timer);
  }, [!!timeslots.length]);

  const checkActiveTimeslot = () => {
    const now = moment();

    const active = timeslots.find((i) => {
      const from = moment(i.fromTime, 'HH:mm');
      const to = moment(i.toTime, 'HH:mm');
      return now.isSameOrAfter(from) && now.isBefore(to);
    });
    setActiveTimeslot(active);
  };

  const getTimeslots = async () => {
    if (!branchIdFromQuery) return;
    const params: ITimeslotParams = {
      date: moment().format('YYYY-MM-DD'),
      branchId: Number(branchIdFromQuery),
    };
    const res = await timeslotsServices
      .getTimeslots(params)
      .then((res) => res.data);
    const limitTime = moment().subtract(1.5, 'hours');
    setTimeslots(
      res.filter((i) =>
        moment(i.fromTime, 'HH:mm').isSameOrAfter(limitTime, 'minute'),
      ),
    );
  };

  useEffect(() => {
    getTimeslotsBranches();
  }, [activeTimeslot?.id]);

  const getTimeslotsBranches = async () => {
    if (!branchIdFromQuery || !activeTimeslot) return;
    setLoading(true);
    try {
      const res = await timeslotsBranchesServices
        .getTimeslotsBranches({
          branchId: Number(branchIdFromQuery),
          timeslotId: activeTimeslot.id,
          date: moment().format('YYYY-MM-DD'),
        })
        .then((res) => res.data);
      // const arrayMock = new Array(48).fill(null).map((_, index) => ({
      //   ...res[0],
      //   id: index + 1,
      // }));
      if (!!timeslotsBranches.length) {
        playPringtone();
      }
      setTimeslotsBranches(res);
    } finally {
      setLoading(false);
    }
  };

  const playPringtone = () => {
    new Audio(ringtone).play().catch(() => {
      console.log('ringtone playback prevented');
    });
  };

  return (
    <div className='queue-with-timeslots-page'>
      <div className='queue-with-timeslots-page__header'>
        <ul className='queue-with-timeslots-page__times'>
          {timeslots.map((i) => (
            <li
              className={cn('queue-with-timeslots-page__time', {
                'queue-with-timeslots-page__time--active':
                  activeTimeslot?.id === i.id,
                'queue-with-timeslots-page__time--inactive':
                  activeTimeslot &&
                  moment(i.fromTime, 'HH:mm').isBefore(
                    moment(activeTimeslot.fromTime, 'HH:mm'),
                    'minute',
                  ),
              })}
              key={i.id}
            >
              <span>{i.fromTime}</span>
              <span className='queue-with-timeslots-page__colon'>-</span>
              <span>{i.toTime}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className='queue-with-timeslots-page__container'>
        <div className='queue-with-timeslots-page__counts'>
          {`${i18n.reserved}`}
          <b>{`${timeslotsBranches.length}/${activeTimeslot?.theoryCapacity}`}</b>
          {i18n.capacity}
        </div>
        <TimeslotsBranchesList
          timeslotsItems={timeslotsBranches}
          loading={loading}
        />
      </div>
    </div>
  );
};
